// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem, ShowInput } from 'components';
import React, { ReactElement } from 'react';
import './qualificationsTechnicalDevice.scss';
import { useTranslation } from 'react-i18next';
import { TechnicalDeviceModel } from 'api/types/Technical';

interface Props {
  userId: number | null;
  dataTechnicalDevice: TechnicalDeviceModel[] | null | undefined;
}

const QualificationsTechnicalDevice = (props: Props): ReactElement => {
  const { userId, dataTechnicalDevice } = props;
  const { t } = useTranslation('employee');

  return (
    <>
      {dataTechnicalDevice &&
      dataTechnicalDevice !== null &&
      Object.keys(dataTechnicalDevice)?.length > 0 ? (
        <Box
          id="userTechnicalDeviceBox"
          name={t('userTechnicalDevice.technicalDevice')}
          noMarginBottom
          noShadow
          noPadding
          noRadius
          lightHeader
        >
          <div className="userTechnicalDeviceContent">
            {dataTechnicalDevice?.some((i) => i.qualificationId === 676) ? (
              <ShowInput
                id="dataBookNumberTechnicalTextBox"
                label={t('userTechnicalDevice.operatorBookNumber')}
                data={
                  dataTechnicalDevice?.find((i) => i.qualificationId === 676)
                    ?.qualificationNumber
                }
                title
                toLeft
              />
            ) : (
              ' '
            )}
            <div className="userTechnicalDeviceDetail">
              {Object.keys(dataTechnicalDevice)?.map((k) =>
                dataTechnicalDevice[k]?.qualification?.name !==
                'Numer książeczki operatora' ? (
                  <DesktopItem
                    id="qualifications"
                    name={dataTechnicalDevice?.[k]?.qualification?.description}
                  >
                    <>
                      {dataTechnicalDevice?.[k]?.qualificationNumber !== null &&
                      dataTechnicalDevice?.[k]?.qualificationNumber !== '' &&
                      dataTechnicalDevice?.[k]?.qualificationNumber !== ' ' ? (
                        <div className="technicalDeviceDetailBox">
                          <div className="technicalDeviceLabel">
                            {t('userTechnicalDevice.qualificationNumber')}
                          </div>
                          <div className="technicalDeviceValue">
                            {dataTechnicalDevice?.[k]?.qualificationNumber}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {dataTechnicalDevice?.[k]
                        ?.additionalInfoInQualification !== null ? (
                        <div className="technicalDeviceDetailBox">
                          <div className="technicalDeviceLabel">
                            {t(
                              'userTechnicalDevice.additionalInfoInQualification'
                            )}
                          </div>
                          <div className="technicalDeviceValue">
                            {
                              dataTechnicalDevice?.[k]
                                ?.additionalInfoInQualification
                            }
                          </div>
                        </div>
                      ) : (
                        ''
                      )}

                      <div className="borderTop" />
                    </>
                  </DesktopItem>
                ) : (
                  ''
                )
              )}
            </div>
          </div>
        </Box>
      ) : null}
    </>
  );
};

export default QualificationsTechnicalDevice;
